import apiService, { buildQueryString } from './api';
class ServicosService {
    // Listar serviços
    async list(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/servicos${queryString}`);
        return response.data;
    }
    // Buscar serviço por ID
    async getById(id) {
        const response = await apiService.get(`/servicos/${id}`);
        return response.data;
    }
    // Criar serviço
    async create(data) {
        const response = await apiService.post('/servicos', data);
        return response.data;
    }
    // Atualizar serviço
    async update(id, data) {
        const response = await apiService.put(`/servicos/${id}`, data);
        return response.data;
    }
    // Deletar serviço (desativar)
    async delete(id) {
        await apiService.delete(`/servicos/${id}`);
    }
    // Obter categorias
    async getCategorias() {
        const response = await apiService.get('/servicos/categorias');
        return response.data;
    }
    // Obter estatísticas
    async getStats() {
        const response = await apiService.get('/servicos/stats');
        return response.data;
    }
    // Buscar serviços
    async buscar(query) {
        const response = await apiService.get(`/servicos/buscar?query=${encodeURIComponent(query)}`);
        return response.data;
    }
    // Buscar serviços para orçamentos (pesquisa ao vivo)
    async searchServicos(search) {
        if (!search.trim())
            return [];
        const response = await apiService.get(`/servicos/buscar?query=${encodeURIComponent(search)}`);
        return response.data;
    }
}
// Funções utilitárias
export const formatarPreco = (valor) => {
    return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    }).format(valor);
};
export const getCategoriaLabel = (categoria) => {
    const labels = {
        'ecra': 'Ecrã',
        'bateria': 'Bateria',
        'upgrade': 'Upgrade',
        'carregamento': 'Carregamento',
        'reparacao': 'Reparação',
        'manutencao': 'Manutenção'
    };
    return labels[categoria] || categoria;
};
export const getStatusServico = (ativo) => {
    return ativo
        ? { label: 'Ativo', color: 'green' }
        : { label: 'Inativo', color: 'red' };
};
const servicosService = new ServicosService();
export default servicosService;
